import React, { Component } from "react";

import { Center, VStack, Divider } from "@chakra-ui/react";
import CoreService from "../../services/CoreService";
import ConfigService from "../../services/ConfigService";

import "../../assets/css/main.css";
import JavascriptHelpers from "../../components/lib/Javascript/JavascriptHelpers";

import SchemaSelectorStrip from "./Components/SchemaSelectorStrip";
import HistoryPanel from "./Components/HistoryPanel";
import InboundQueuePanel from "./Components/InboundQueuePanel";

import RoleManager from "../../models/RoleManager";
import { AppSecurityKey } from "../../models/AppSecurityKey";



export default class ObsHomePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            watchListLastUpdated: JavascriptHelpers.isoUtcNow()
        }
        this.coreService = new CoreService();
        this.configService = new ConfigService();

    }


    render() {

        var hasRoleRights = RoleManager.hasRoleRights(AppSecurityKey.VIEW_OBSHOME, this.props.userSession.token);

        return (
            ((this.props.currentSchemaId) && (hasRoleRights)) ?
                <Center className="main">
                    <VStack width='-webkit-fill-available'>
                        {/* <h1>HOME</h1> */}
                        <SchemaSelectorStrip
                            userSession={this.props.userSession}
                            schemas={this.props.userSession.schemas}
                            currentSchemaId={this.props.currentSchemaId}
                            onToastRequest={this.props.onToastRequest}
                            onCurrentSchemaIdUpdateRequest={this.props.onCurrentSchemaIdUpdateRequest}
                            onErrorPageRequest={this.props.onErrorPageRequest}
                            onObservationPageRequest={this.props.onObservationPageRequest}
                            suspendedTags={this.props.suspendedTags}
                            onSuspendedObservationChange={this.props.onSuspendedObservationChange}
                        />

                        {this.props.onlineInfo.isConnected && this.props.userSession.inboundQueueEnabled &&
                        <InboundQueuePanel
                            userSession={this.props.userSession}
                            currentLocationId={this.props.currentLocationId}
                            onToastRequest={this.props.onToastRequest}
                            onMsgBoxRequest={this.props.onMsgBoxRequest}
                            currentSchemaId={this.props.currentSchemaId}
                            schemas={this.props.userSession.schemas}
                            locations={this.props.userSession.locations}
                            onErrorPageRequest={this.props.onErrorPageRequest}
                            onObservationPageRequest={this.props.onObservationPageRequest}
                            autoRefresh={this.props.autoRefresh}
                            onToggleAutoRefresh={this.props.onToggleAutoRefresh}
                            autoRefreshTriggerKey={this.props.autoRefreshTriggerKey}
                            parentComponent="observationhome"
                        />
                        }




                        {/* temporarily disable until we work on offline
                        <LocalGrid
                            userSession={this.props.userSession}
                            onErrorPageRequest={this.props.onErrorPageRequest}
                        />
                        <Divider />
                        */}

                        {this.props.onlineInfo.isConnected &&
                            <HistoryPanel
                                userSession={this.props.userSession}
                                onToastRequest={this.props.onToastRequest}
                                onMsgBoxRequest={this.props.onMsgBoxRequest}
                                currentSchemaId={this.props.currentSchemaId}
                                schemas={this.props.userSession.schemas}
                                locations={this.props.userSession.locations}
                                onErrorPageRequest={this.props.onErrorPageRequest}
                                showCharts={false}
                                onObservationPageRequest={this.props.onObservationPageRequest}
                                autoRefresh={this.props.autoRefresh}
                                onToggleAutoRefresh={this.props.onToggleAutoRefresh}
                                autoRefreshTriggerKey={this.props.autoRefreshTriggerKey}
                                parentComponent="observationhome"
                                onViewReportRequest={this.props.onViewReportRequest}
                                globalSearchParams={this.props.globalSearchParams}
                                onGlobalSearchParamsChange={this.props.onGlobalSearchParamsChange}
                                globalFilterParams={this.props.globalFilterParams}
                                onGlobalFilterParamsChange={this.props.onGlobalFilterParamsChange}
                            />
                        }

                    </VStack>
                </Center>
                : <span />
        )

    }
}